// @owners { team: patient-fulfillment }
// eslint-disable-next-line import/no-deprecated
import { fetchInsurances } from '~shared/actions/insurances';
import { openModal } from '~shared/actions/modal';
import { selectUser } from '~shared/actions/ui/users';
import { updateCashPay } from '~shared/actions/users';
import { getInsurancesForUser } from '~shared/features/insurances/selectors/getInsurancesForUser';
import { getIsNeedsInsuranceForUser } from '~shared/features/insurances/selectors/getIsNeedsInsuranceForUser';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { getUserCashPayOnly } from '~shared/features/users/selectors/getUserCashPayOnly';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { type Event } from '~shared/lib/analytics/src/types';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import ProfileInsurances, { type Props } from './ProfileInsurances';

type OwnProps = { userID: number };

const mapStateToProps = (state: ReduxStateShared, ownProps: OwnProps) => {
  const { fetchInsurancesLoading } = getLoading(state);
  const userID = ownProps?.userID;

  return {
    isFetchInsurancesLoading: fetchInsurancesLoading,
    insurances: getInsurancesForUser(state, {
      userID,
    }),
    isNeedsInsurance: getIsNeedsInsuranceForUser(state, {
      userID,
    }),
    isCashPayOnly: getUserCashPayOnly(state, {
      userID,
    }),
    userID,
  };
};

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => ({
  // eslint-disable-next-line import/no-deprecated
  fetchInsurances: () => dispatch(fetchInsurances()),
  openModal: (...args: Parameters<typeof openModal>) => dispatch(openModal(...args)),
  selectUser: (...args: Parameters<typeof selectUser>) => dispatch(selectUser(...args)),
  sendAnalyticsEvent: (event: Event) => {
    dispatch(sendAnalyticsEvent(event));
  },
  updateCashPay: (...args: Parameters<typeof updateCashPay>) => dispatch(updateCashPay(...args)),
});

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: ReturnType<typeof mapDispatchToProps>,
): Props => {
  const { userID } = stateProps;
  const { sendAnalyticsEvent, updateCashPay: updateUserCashPay, ...newDispatchProps } = dispatchProps;

  return {
    ...stateProps,
    ...newDispatchProps,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    updateCashPay: async () => {
      const { success } = await updateUserCashPay(userID, true);
      if (success) {
        sendAnalyticsEvent(
          createEvent(EVENTS.CASH_PAY_ONLY_SET, {
            source: 'profile',
            'new value': true,
          }),
        );
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProfileInsurances);
